import { requestCorpObituaryList } from "@/apis/obituary_api";

import {
  deleteCorpTokenInLocalStorage,
  setTokenInLocalStorage,
  setCorpInfoLocalStorage
} from "@/utils/oauth";

import { deleteAccessTokenInHeader } from "@/apis/common_api";

import store from "@/store";
import router from "@/router";
import { requestToken } from "../apis/auth_api";

import User from "@/apis/user";
import CorpClient from "@/apis/corpClient";
import AdminClient from "@/apis/adminClient";

const client = new CorpClient();
const user = new User(client);

const state = {
  accessToken: localStorage.getItem("access_token"),
  type: "corp",
  // corp: null,

  corp: {
    id: localStorage.getItem("corpId"),
    userId: localStorage.getItem("corpUserId"),
    name: localStorage.getItem("corpName"),
    phone: localStorage.getItem("corpPhone"),
    Account: localStorage.getItem("corpAccount"),
    SecurityNumber: localStorage.getItem("corpSecurityNumber"),
    marketingAgree: localStorage.getItem("corpMarketingAgree"),
    approve: localStorage.getItem("corpApprove"),
    approvePassword: localStorage.getItem("corpApprovePassword")
  },
  corpDirectorList: [],
  corpDirectorPage: null,
  corpDirectorPageTotal: 0,
  corpDirectorTotalElements: 0,

  corpObituaryList: [],
  corpObituaryPage: null,
  corpObituaryPageTotal: 0,
  corpObituaryTotalElements: 0,
  isCorpAuthenticated:
    localStorage.getItem("access_type") === "corp" &&
    localStorage.getItem("access_token")
};

const resetToken = state => {
  deleteCorpTokenInLocalStorage();
  deleteAccessTokenInHeader();
  state.accessToken = null;
};

const getters = {
  isCorpAuthenticated(state) {
    return state.isCorpAuthenticated;
  },
  corpInfo(state) {
    return state.corp;
  },

  getCorpDirectorList(state) {
    return state.corpDirectorList;
  },
  getCorpDirectorPage(state) {
    if (state.corpDirectorPage === null) {
      return 0;
    } else {
      return state.corpDirectorPage.pageNumber + 1;
    }
  },
  getCorpDirectorPageTotal(state) {
    return state.corpDirectorPageTotal;
  },
  getCorpDirectorTotalElements(state) {
    return state.corpDirectorTotalElements;
  },
  getCorpObituaryList(state) {
    return state.corpObituaryList;
  },
  getCorpObituaryPage(state) {
    if (state.corpObituaryPage === null) {
      return 0;
    } else {
      return state.corpObituaryPage.pageNumber + 1;
    }
  },
  getCorpObituaryPageTotal(state) {
    return state.corpObituaryPageTotal;
  },
  getCorpObituaryTotalElements(state) {
    return state.corpObituaryTotalElements;
  }
};

const mutations = {
  SET_CORP_ACCESS_TOKEN(state, data) {
    state.accessToken = data;
    state.isCorpAuthenticated = true;
  },
  LOGIN(state) {
    // state.accessToken = localStorage.getItem("access_token");
    router.push("/");
    state.isCorpAuthenticated = true;
    store.dispatch("REQUEST_OBITUARY_ALL_LIST");
  },
  LOGOUT_CORP(state) {
    resetToken(state);
    state.corp = null;
    state.isCorpAuthenticated = false;
    store.commit("REQUEST_OBITUARY_ALL_LIST_INIT");
  },

  // new
  CORP_DETAIL(state, data) {
    state.corp = data.resultCorp;
  },

  SET_CORP_DIRECTOR_LIST(state, data) {
    state.corpDirectorList = data.resultCorpDirectorList;
    state.corpDirectorPage = data.page;
    state.corpDirectorPageTotal = data.pageTotal;
    state.corpDirectorTotalElements = data.totalElemtnts;
  },
  SET_CORP_OBITUARY_LIST(state, data) {
    state.corpObituaryList = data.resultObituaryList;
    state.corpObituaryPage = data.page;
    state.corpObituaryPageTotal = data.pageTotal;
    state.corpObituaryTotalElements = data.totalElemtnts;
  }
};

const actions = {
  async REQUEST_LOGOUT_CORP({ commit }) {
    try {
      commit("START_LOADING");
      const data = await user.logout();
      commit("LOGOUT_CORP");
      router.replace("/corp/loginDo");
    } catch (e) {
      if (e === "refresh") {
        return;
      }

      console.error(e);
      alert(
        "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
      );
    } finally {
      commit("END_LOADING");
    }
  },

  // new
  async REQUEST_CORP_LOGIN({ commit }, parameter) {
    try {
      commit("START_LOADING");
      // 엑세스 토큰 발급
      const token = await requestToken(parameter);

      if (token.data?.result !== "success") {
        alert(token.data.message);

        return;
      }
      await setTokenInLocalStorage({ ...token.data, type: parameter.type });

      await user.setToken(token.data.access_token);

      const data = await user.login(parameter.user);

      if (data?.result !== "success") {
        alert(data.message);
        return;
      }

      setCorpInfoLocalStorage(data.resultCorp);
      commit("CORP_DETAIL", data);

      if (data.resultCorp.password === "0000") {
        router.push("/passwordSetting");
        return;
      }

      window.location.reload();
    } catch (e) {
      if (e === "refresh") {
        return;
      }
      console.error(e);
      alert(
        "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
      );
    } finally {
      commit("END_LOADING");
    }
  },

  // nes
  async CORP_DETAIL({ commit, state }) {
    try {
      commit("START_LOADING");
      const data = await user.getDetail();

      // setMemberInfoLocalStorage(getMember.data.resultMember);

      if (data?.result !== "success") {
        alert(data.message);
        router.push("/login");
        return;
      }

      commit("CORP_DETAIL", data);
    } catch (error) {
      console.error(error);
    } finally {
      commit("END_LOADING");
    }
  },

  // new - 회원탈퇴
  // FIXME : 아직 호출하는 곳이 없음
  async REQUEST_DELETE_CORP({ commit }, parameter) {
    try {
      commit("START_LOADING");
      const data = await user.delete(parameter);

      if (data?.result !== "success") {
        return alert(data.message);
      }

      alert("탈퇴가 완료되었습니다.");
      commit("LOGOUT");
      router.push("/login");
    } catch (e) {
      if (e === "refresh") {
        return;
      }

      alert(e);
    } finally {
      commit("END_LOADING");
    }
  },
  // new
  async REQUEST_CHANGE_MARKET_AGREE_CORP({ commit }, parameter) {
    try {
      commit("START_LOADING");
      const data = await user.changeMarketingAgree(parameter);

      if (data.result !== "success") {
        return alert(data.message);
      }

      commit("CORP_DETAIL", data);
    } catch (e) {
      if (e === "refresh") {
        return;
      }

      alert("서비스 오류가 있습니다. 관리자에게 문의해주세요");
    } finally {
      commit("END_LOADING");
    }
  },

  async REQUEST_CORP_ADD_ACCOUNT({ commit }, parameter) {
    try {
      commit("START_LOADING");
      const data = await user.addAccount(parameter);

      if (data.result !== "success") {
        return alert(data.message);
      }

      commit("CORP_DETAIL", data);
    } catch (e) {
      if (e === "refresh") {
        return;
      }

      console.error(e);

      alert("서비스 오류가 있습니다. 관리자에게 문의해주세요");
    } finally {
      commit("END_LOADING");
    }
  },
  async REQUEST_CORP_ADD_SECURITY_NUMBER({ commit }, parameter) {
    try {
      commit("START_LOADING");
      const data = await user.addSecurityNumber(parameter);

      if (data.result !== "success") {
        return alert(data.message);
      }

      commit("CORP_DETAIL", data);
    } catch (e) {
      if (e === "refresh") {
        return;
      }

      console.error(e);

      alert("서비스 오류가 있습니다. 관리자에게 문의해주세요");
    } finally {
      commit("END_LOADING");
    }
  },

  // 상조 소속 장례지도사 조회
  async REQUEST_CORP_DIRECTOR_LIST({ commit }, parameter) {
    try {
      commit("START_LOADING");

      const data = await user.getDirectorList(parameter);

      if (data?.result !== "success") {
        return alert(data.message);
      }

      commit("SET_CORP_DIRECTOR_LIST", data);
    } catch (e) {
      if (e === "refresh") {
        return;
      }

      alert(
        "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
      );
    } finally {
      commit("END_LOADING");
    }
  },

  async REQUEST_DELETE_CORP_DIRECTOR({ commit }, parameter) {
    try {
      commit("START_LOADING");

      const data = await user.deleteCorpDirector(parameter);

      if (data?.result !== "success") {
        return alert(data.message);
      }

      window.location.reload();
    } catch (e) {
      if (e === "refresh") {
        return;
      }

      console.error(e);

      alert(
        "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
      );
    } finally {
      commit("END_LOADING");
    }
  },

  // 상조 등록 부고 리스트 조회
  async REQUEST_CORP_OBITUARY_LIST({ commit }, parameter) {
    try {
      commit("START_LOADING");

      const res = await requestCorpObituaryList(parameter);

      const { data } = res;

      if (data?.result !== "success") {
        return alert(data.message);
      }

      commit("SET_CORP_OBITUARY_LIST", data);
    } catch (e) {
      if (e === "refresh") {
        return;
      }

      console.error(e);

      alert(
        "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
      );
    } finally {
      commit("END_LOADING");
    }
  },
  // new
  async REQUEST_MEMBER_RESET_PASSWORD({ commit }, parameter) {
    try {
      commit("START_LOADING");
      const admin = new AdminClient();

      const data = await admin.resetPassword(parameter);

      if (data?.result !== "success") {
        return alert(data.message);
      } else {
        alert("비밀번호가 초기화되었습니다");
      }
    } catch (e) {
      if (e === "refresh") {
        return;
      }

      alert(
        "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
      );
    } finally {
      commit("END_LOADING");
    }
  },

  async REQUEST_DISCONNECT_CORP_DIRECTOR({ commit }, parameter) {
    try {
      commit("START_LOADING");
      const admin = new AdminClient();

      const data = await admin.disconnectCorpDirector(parameter);

      if (data?.result !== "success") {
        return alert(data.message);
      } else {
        alert("헤당 지도사가 탈퇴 되었습니다");
      }
    } catch (e) {
      if (e === "refresh") {
        return;
      }

      alert(
        "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
      );
    } finally {
      commit("END_LOADING");
    }
  }
};

export default { mutations, state, actions, getters };
